import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { DocumentUrlPipe } from "../../../shared/pipes";
import { ValidationMessage } from "../../../validation";
import { Observable, Subscription } from "rxjs";
import { CampaignThemeTacticListItemDto } from "../../../client-core/dtos/campaigns.model";
import { PaginationInfo } from "../../../client-core/api-response-models";
import { TacticCatalogSearch, TacticId } from "../../../client-core/dtos/tactics.model";
import { TacticService } from "../../../client-core/services/tactic.service";
import { CampaignService, DocumentService } from '../../../client-core/services';
import { UserService } from "../../../client-core/services/user.service";
import { AuthService } from "../../../+auth/auth.service";
import { NewCampaignService } from "app/client-core/services/new-campaign-service";


@Component({
    selector: 'campaign-tab-tactic-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    providers: [
        // CampaignService
    ]
})
export class CampaignGridTacticsComponent implements OnInit, OnDestroy {
    @Input()
    programId: number;

    @Input()
    campaignThemeId: number;

    @Output() tacticImageClicked = new EventEmitter();

    docmentUrlPipe: DocumentUrlPipe;

    public validationMessages: ValidationMessage;
    submitting: boolean;
    selectedTactics: any;

    rows: Observable<CampaignThemeTacticListItemDto[]>;

    paginationInfo: PaginationInfo;
    pageSizeOptions: Array<number> = [10, 25, 50, 100, 250];

    _searchModel: TacticCatalogSearch;
    @Input() showNoDataMessage: boolean;
    @Input() noDataMessage: string;
    @Input() pageSize: number;
    hasData: boolean;

    private searchSubscription: Subscription;

    public applySearchModel() {
        this.paginationInfo = new PaginationInfo(0, 50);
        this.tacticService.newTacticSearchModelArrived.next(this._searchModel);
    }

    public search(): any {
        this._searchModel.campaignThemeId = this.campaignThemeId;
        let params: any = Object.assign({ PageSize: this.pageSize || this.paginationInfo.pageSize, pageIndex: this.paginationInfo.pageIndex }, this._searchModel);
        console.log('>>applySearchModelChanges', params)
        this._getCampaignThemeTactics(params);
    }

    constructor(
        private tacticService: TacticService,
        private userService: UserService,
        private documentService: DocumentService,
        private authService: AuthService,
        private campaignService: NewCampaignService
    ) {
        this.paginationInfo = new PaginationInfo(0, 50);
        this.tacticService.programTacticSaved.subscribe(() => {
            this.search();
        })
        this.docmentUrlPipe = new DocumentUrlPipe(documentService, authService);
    }


    ngOnInit() {

        this._searchModel = new TacticCatalogSearch();
        this.searchSubscription = this.tacticService.newTacticSearchModelArrived
            .debounceTime(800)
            .subscribe((model) => {
                this._searchModel = model;
                this.search();
            });

        this.search();
    }

    ngOnDestroy() {
        if (this.searchSubscription)
            this.searchSubscription.unsubscribe();
    }

    private _getCampaignThemeTactics(event: any = {}): void {
        this.submitting = true;
        if (this.pageSize && this.pageSize > 0) {
            event = {
                ...event,
                pageSize: this.pageSize
            }
        }
        this.campaignService.getCampaignThemeTactics(event)
            .subscribe(res => {
                if (!res.hasError) {
                    this.rows = Observable.of(res.data.items);
                    this.paginationInfo = PaginationInfo.createForApiPagedResponse(res.data);
                    this.hasData = res.data.items && res.data.items.length > 0;
                    this.submitting = false;
                } else {
                    this.validationMessages = new ValidationMessage(res.error, true, "Data could not be retrieved");
                }
            },
                (err: any) => {
                    this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
                },
                () => {
                    this.submitting = false;
                });
    }

    addToFavorite(value: number): void {
        let tacticId = new TacticId(value);
        this.userService.AddTacticAsFavorite(tacticId)
            .subscribe(res => {
                if (!res.hasError && res.data) {
                    this.validationMessages = new ValidationMessage(null, true, "Added favorite")
                        .pushMessage("Successfully added as a favorite")
                        .isSuccess();
                    this.tacticService.newFavoriteAdded.next(new TacticId(res.data));
                } else {
                    this.validationMessages = new ValidationMessage(res.error, true, "Error occured");
                }
            },
                (err: any) => {
                    this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
                },
                () => {
                    this.submitting = false;
                });

    }

    viewDetails(value: number): void {
        let tacticId = new TacticId(value);
        this.tacticService.showTacticInfo.next(tacticId);
    }

    selectTactic(value: number, productType): void {
        let tacticId = new TacticId(value);
        this.tacticService.selectTacticInfo.next({id: tacticId, productType: productType});
    }

    onPageSizeChange(size: number) {
        console.log('grid>>onPageSizeChange', size);
        this.paginationInfo.pageSize = size;
        this.search();
    }

    firstPage() {
        if (!this.paginationInfo.hasPreviousPage)
            return;

        this.paginationInfo.pageIndex = 0;
        this.search();
    }

    previousPage() {
        if (!this.paginationInfo.hasPreviousPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.pageIndex - 1;
        this.search();
    }

    nextPage() {
        if (!this.paginationInfo.hasNextPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.pageIndex + 1;
        this.search();
    }

    lastPage() {
        if (!this.paginationInfo.hasNextPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.totalPages - 1;
        this.search();
    }

    onImageClicked(item: CampaignThemeTacticListItemDto) {
        const url = this.docmentUrlPipe.transform(item.tacticDocumentId, 'assets/img/thumbnails/thumbnail-300x200.png');
        this.tacticImageClicked.emit(url);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/campaign-modal-component/tactics/grid.component.ts